"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
require("./upload");
require("./intervenants");
require("./share-delete-document");
require("./bon-commandes");
// Champ de recherche présent sur toutes les pages
$(function () {
    $('.box-collapse-tasks').on('hide.bs.collapse', function () {
        var wfId = $(this).data("workflow-id");
        var blocWf = $(this).parent().find(".bloc-workflow.active.workflow-" + wfId);
        if (blocWf) {
            blocWf.removeClass("active");
        }
    }).on('show.bs.collapse', function () {
        var wfId = $(this).data("workflow-id");
        var blocWf = $(this).parent().find(".bloc-workflow:not(.active).workflow-" + wfId);
        if (blocWf) {
            blocWf.addClass("active");
        }
    });
    if ($("#search-doc-affaire-titles").length > 0) {
        var getResultForSearch = function getResultForSearch() {
            $.map($("#search-doc-affaire-titles a.nav-link"), function (e) {
                var $link = $(e),
                    $container = $($link.attr("href")),
                    param = { term: $("input#Keywords").val() };
                $container.load($link.data("url") + "?" + $.param(param), function (data) {
                    var nbreResult = $("td[colspan]", data).length > 0 ? 0 : $("tbody tr", data).length;
                    $link.text($link.data("title") + " - " + nbreResult + " r\xE9sultats");
                    var callBack = $link.data("callback");
                    if (callBack) {
                        $container[callBack]();
                    }
                });
            });
        };
        $("button.btn-search-doc-affaire").on("click", function () {
            getResultForSearch();
        });
        if ($("#search-doc-affaire-titles a.nav-link.active").length === 0) {
            $("#search-doc-affaire-titles a.nav-link:first").trigger("click");
        }
        getResultForSearch();
    }
    var $search = $(".search-affaire");
    $search.on("select2:select", function (e) {
        var event = e;
        var selected = event.params.data.id;
        var keywords = $search.data("keywords");
        if (selected) {
            document.location.assign($search.data("target").replace(/\d+$/g, "") + selected);
        } else {
            document.location.assign($search.data("searchPage") + "/" + (keywords || ""));
        }
    });
    $search.select2({
        placeholder: "Rechercher une affaire",
        multiple: true,
        templateResult: function templateResult(selected) {
            var affaire = selected;
            if (!affaire.id) {
                return $("<em>Acc\xE9der \xE0 la page de recherche</em>");
            }
            var cloturee = "";
            if (affaire.statut == 2) {
                cloturee = "[Clôturée]";
            }
            return $("<span><strong>" + affaire.codeAffaire + "</strong>  " + affaire.libelle + " " + cloturee + "\n                    <br />" + affaire.codeInsee + " " + affaire.communeTravaux + "</span>");
        },
        ajax: {
            url: $search.data("url"),
            dataType: "json",
            processResults: function processResults(data) {
                $search.data("keywords", data.keywords);
                data.results.unshift({
                    id: 0,
                    text: ""
                });
                return {
                    results: $.map(data.results, function (d) {
                        d.text = d.codeAffaire;
                        return d;
                    })
                };
            }
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Affaire/index.ts
// module id = 596
// module chunks = 0